import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { InfoBoxComponent } from '../info-box.component';
import { TranslateModule } from '@ngx-translate/core';
import { CustomLinkDirective } from '@shared/directives/custom-link/custom-link.directive';
import { Store } from '@ngrx/store';
import { StoreState } from '@store/store.state';
import { userSelectors } from '@store/selectors/user.selectors';

export type NoDataSpecificType = 'PROCEDURE' | 'INVOICE' | 'GENERIC';

@Component({
  selector: 'ac-no-data-found',
  standalone: true,
  imports: [InfoBoxComponent, TranslateModule, CustomLinkDirective],
  templateUrl: './no-data-found.component.html',
  styleUrls: ['./no-data-found.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoDataFoundComponent {
  @Input({ required: false }) specific: NoDataSpecificType = 'GENERIC';
  protected readonly _mailSig = inject(Store<StoreState>).selectSignal(userSelectors.helpEmail);
}
